import React, { useEffect, useState } from 'react';
import { isEmail } from 'validator';
import { connect } from 'react-redux';
import { filter } from 'lodash';
import { selector } from 'apps/services';
import { attemptSetLanguage } from 'apps/modules/app/AppActions';
import { Translation, withTranslation } from 'react-i18next';
import { PREFERRED_COUNTRIES, COUNTRIES_EXTN, ENGLISH_LANG, LANGUAGES, TOAST_AUTO_CLOSE, TOAST_POSITION, SESSION_STATUS_STARTED } from 'configs/constants';
import { Button, FormGroup, Input } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { attemptUpdateQuickshop, attemptResetNotificationState, attemptGetPOSSession, attemptGetTopMeasurementData, attemptGetMeasurementData, attemptGetReceiptData } from 'apps/modules/quickshopweb/QuickshopWebActions';
import { Footer } from 'components/core';
import { useParams } from 'react-router-dom';
import BatteryGauge from 'react-battery-gauge';
import ReactPhoneInput from 'react-phone-input-2';
import { produce, setAutoFreeze } from 'immer';
import { faSave, faCancel, faEdit } from '@fortawesome/free-solid-svg-icons';
import { CircularGaugeComponent, AxesDirective, AxisDirective, Inject, PointersDirective, PointerDirective, Annotations, AnnotationDirective, AnnotationsDirective } from '@syncfusion/ej2-react-circulargauge';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Legend, DateTime, Tooltip, LineSeries, Highlight } from '@syncfusion/ej2-react-charts';
import { getText } from 'helpers/app/getText';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';

function POSSession({ attemptGetPOSSession, attemptUpdateQuickshop, attemptResetNotificationState, attemptGetReceiptData, attemptGetTopMeasurementData, attemptGetMeasurementData, attemptSetLanguage, quickshopweb, app }) {
  const { possessionid } = useParams();
  setAutoFreeze(false);
  const [isEditCustomer, setIsEditCustomer] = useState(false);

  const [fields, setFields] = useState({
    customerName: '',
    customerEmail: '',
    customerMobilePhone: '',
    customerVatNumber: '',
    taxpayerIdentificationNumber: '',
  });

  const [errors, setErrors] = useState({
    customerEmail: '',
  });

  useEffect(() => {
    attemptGetPOSSession(possessionid);
    attemptGetTopMeasurementData(possessionid);
  }, []);

  useEffect(() => {
    if (quickshopweb.get('isQuickshopUpdated')) {
      toast.dismiss();
      toast.success(getText('notifications:QUICKSHOP_UPDATED_MSG'), { autoClose: 3000 });
      attemptResetNotificationState('isQuickshopUpdated');
      setIsEditCustomer(false);
      attemptGetPOSSession(possessionid);
    }
  }, [quickshopweb.get('isQuickshopUpdated')]);

  useEffect(() => {
    if (quickshopweb.get('error')?.code === 404) {
      toast.dismiss();
      toast.error(quickshopweb.get('error')?.description ?? getText('notifications:POS_SESSION_ENDED_MSG'), { autoClose: 6000 });
      attemptResetNotificationState('error');
    }
  }, [quickshopweb.get('error')]);

  useEffect(() => {
    if (quickshopweb.get('posSession')?._id) {
      const posSession = quickshopweb.get('posSession');
      attemptGetMeasurementData(posSession._id);
      setFields(
        produce((draft) => {
          draft.customerName = posSession.customerName;
          draft.customerEmail = posSession.customerEmail;
          draft.customerMobilePhone = posSession.customerMobilePhone;
          draft.customerVatNumber = posSession.customerVatNumber;
          draft.taxpayerIdentificationNumber = posSession.taxpayerIdentificationNumber;
        }),
      );
    }
  }, [JSON.stringify(quickshopweb.get('posSession'))]);

  const onLanguageChange = (opt) => {
    const lang = filter(LANGUAGES, { code: opt.code })?.[0]?.code || LANGUAGES[0].code;
    attemptSetLanguage(lang);
  };

  const onGetReceipt = () => {
    attemptGetReceiptData(possessionid);
  };

  const onChange = (ev) => {
    const { name, value } = ev.target;

    setFields(
      produce((draft) => {
        draft[name] = value;
      }),
    );
  };

  const onPhoneChange = (val) => {
    setFields(
      produce((fields) => {
        fields.customerMobilePhone = val;
      }),
    );
  };

  const onSetEditCustomer = () => {
    setIsEditCustomer(!isEditCustomer);
  };

  const loadTwo = (args) => {};

  const validate = (name, value) => {
    switch (name) {
      case 'customerEmail':
        if (value?.length > 0 && !isEmail(value)) {
          return getText('notifications:INVALID_EMAIL_MSG');
        } else {
          return '';
        }
    }
  };

  const onSaveQuickshop = () => {
    let errorList = {};

    Object.keys(fields).map((name) => {
      const error = validate(name, fields[name]);
      if (error?.length > 0) {
        errorList[name] = error;
      }
    });

    if (Object.keys(errorList).length > 0) {
      setErrors(errorList);
      toast.dismiss();
      toast.error(getText('notifications:VALIDATION_ERRORS_MSG'), { autoClose: 3000, position: TOAST_POSITION });
      return;
    }

    const posSession = quickshopweb.get('posSession');
    attemptUpdateQuickshop({
      posSessionID: possessionid,
      merchantID: posSession.merchantID,
      ...fields,
    });
  };

  const posSession = quickshopweb.get('posSession');
  const measurementData = quickshopweb.get('measurementData');
  const topMeasurementData = quickshopweb.get('topMeasurementData');
  const language = app.get('language') || ENGLISH_LANG;
  const lang = filter(LANGUAGES, { code: language })?.[0]?.value || LANGUAGES[0].value;

  const powerData =
    measurementData?.length > 0
      ? filter(measurementData, (data) => {
          if (data.measurementValues?.Power_Active_Import?.value && data.measurementValues?.Power_Active_Import?.value > 0) {
            return data;
          }
        }).map((data) => {
          return {
            x: moment(data.measurementDate).format('YYYY-MM-DD HH:mm:ss'),
            y: parseInt(data.measurementValues?.Power_Active_Import?.value) / 1000,
          };
        })
      : [];

  const currentData =
    measurementData?.length > 0
      ? filter(measurementData, (data) => {
          if (data.measurementValues?.Current_Import?.value && data.measurementValues?.Current_Import?.value > 0) {
            return data;
          }
        }).map((data) => {
          return {
            x: moment(data.measurementDate).format('YYYY-MM-DD HH:mm:ss'),
            y: parseInt(data.measurementValues?.Current_Import?.value),
          };
        })
      : [];

  const soCData =
    measurementData?.length > 0
      ? filter(measurementData, (data) => {
          if (data.measurementValues?.SoC?.value && data.measurementValues?.SoC?.value > 0) {
            return data;
          }
        }).map((data) => {
          return {
            x: moment(data.measurementDate).format('YYYY-MM-DD HH:mm:ss'),
            y: parseInt(data.measurementValues?.SoC?.value),
          };
        })
      : [];

  const SAMPLE_CSS = `
      .control-fluid {
          padding: 0px !important;
      }
      .charts {
        align :center;
      }`;

  const onChartLoad = () => {
    let chart = document.getElementById('charts');
    if (chart) {
      chart.setAttribute('title', '');
    }
  };
  const load = () => {
    let selectedTheme = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Material';
  };

  return (
    <Translation ns="possession">
      {(t, { i18n }) => {
        return (
          <div className="mb-200">
            <ToastContainer autoClose={TOAST_AUTO_CLOSE} position={TOAST_POSITION} />
            <div className="container">
              {posSession?.componentName?.[lang] && (
                <FormGroup className="text-center mt-20">
                  <h2>
                    <b>{posSession.componentName[lang].text}</b>
                  </h2>
                </FormGroup>
              )}
              {posSession.merchantName && <FormGroup className="email-section text-center">{posSession.merchantName}</FormGroup>}
              {posSession.sessionStateCode && (
                <FormGroup className="text-center mb-20">
                  {getText('possession:SESSION_IS')} {posSession.sessionStateCode}
                </FormGroup>
              )}
              {posSession.sessionStateCode === SESSION_STATUS_STARTED && (
                <div>
                  <div className="text-center">
                    <h3>{topMeasurementData?.measurementValues?.SoC?.value || 0}%</h3>
                    <BatteryGauge
                      size={200}
                      value={topMeasurementData?.measurementValues?.SoC?.value ?? 0}
                      animated={true}
                      customization={{
                        batteryMeter: {
                          noOfCells: 10,
                        },
                      }}
                    />
                    <h3>+{topMeasurementData?.measurementValues?.Energy_Active_Import_Register?.value / 1000} kW</h3>
                  </div>
                  <CircularGaugeComponent load={loadTwo} background="transparent" id="container2">
                    <Inject services={[Annotations]} />
                    <AxesDirective>
                      <AxisDirective startAngle={270} endAngle={90} radius="80%" minimum={0} maximum={350} lineStyle={{ width: 30, color: '#d9dadb' }} majorTicks={{ height: 0 }} minorTicks={{ height: 0, width: 0 }} labelStyle={{ position: 'Outside', font: { size: '0px' } }}>
                        <PointersDirective>
                          <PointerDirective type="RangeBar" pointerWidth={40} color="#8bb5f3" value={80} radius="128%" />
                          <PointerDirective type="RangeBar" pointerWidth={30} color="#007bff" value={80} radius="115%" />
                        </PointersDirective>
                        <AnnotationsDirective>
                          <AnnotationDirective content={`<div style="font-size:20px;font-weight:bold;font-family:inherit;">${topMeasurementData?.measurementValues?.Power_Active_Import?.value / 1000} kW</div>`} angle={1} zIndex="1" radius="0%" />
                          <AnnotationDirective content='<div style="font-size:15px;font-family:inherit;">0</div>' angle={255} zIndex="1" radius="102%" />
                          <AnnotationDirective content='<div style="font-size:15px;font-family:inherit;">350</div>' angle={105} zIndex="1" radius="105%" />
                        </AnnotationsDirective>
                      </AxisDirective>
                    </AxesDirective>
                  </CircularGaugeComponent>
                </div>
              )}
              <div className="text-center">
                <div className="mb-20">
                  <a href="javascript:void(0);" onClick={() => onGetReceipt()}>
                    <img src="img/receipt.svg" className="receipt-img" />
                    <p>{getText('possession:PAYMENT_RECEIPT')}</p>
                  </a>
                </div>
                {posSession._id && (
                  <div className="d-flex flex-column customer-box">
                    <div className="d-flex flex-row justify-content-between" style={{ flexBasis: '70%', gap: '5px' }}>
                      <div>
                        <b>{getText('possession:CUSTOMER')}:</b>
                      </div>
                      <div>
                        {isEditCustomer ? (
                          <div className="d-flex flex-row" style={{ gap: '10px' }}>
                            <Button color="success" className="pull-right btn-labeled p-0 px-10" size="sm" onClick={onSaveQuickshop}>
                              <div className="btn-label">
                                <FontAwesomeIcon icon={faSave} size="xs" />
                              </div>
                              <span>{getText('possession:SAVE')}</span>
                            </Button>
                            <Button color="warning" className="pull-right btn-labeled p-0 px-10" size="sm" style={{ color: '#fff' }} onClick={onSetEditCustomer}>
                              <div className="btn-label">
                                <FontAwesomeIcon icon={faCancel} size="xs" />
                              </div>
                              <span>{getText('possession:CANCEL')}</span>
                            </Button>
                          </div>
                        ) : (
                          <Button color="success" className="pull-right btn-labeled p-0 px-10" size="sm" onClick={onSetEditCustomer}>
                            <div className="btn-label">
                              <FontAwesomeIcon icon={faEdit} size="xs" />
                            </div>
                            <span>{getText('possession:EDIT')}</span>
                          </Button>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-grow-1 align-items-baseline row">
                      <div className="d-flex col-12 col-sm-4">{getText('possession:CUSTOMER_NAME')}:</div>
                      <div className="col-12 col-sm-3 d-flex justify-content-start pd-5">{isEditCustomer ? <Input value={fields.customerName} size="sm" name="customerName" onChange={onChange} placeholder={getText('possession:CUSTOMER_NAME')} /> : posSession.customerName}</div>
                    </div>
                    <div className="d-flex flex-row flex-grow-1 align-items-baseline row">
                      <div className="d-flex col-12 col-sm-4">{getText('possession:CUSTOMER_MOBILE')}:</div>
                      <div className="col-12 col-sm-3 d-flex justify-content-start pd-5">{isEditCustomer ? <ReactPhoneInput inputStyle={{ fontSize: '12px' }} onlyCountries={COUNTRIES_EXTN.map((country) => country.code)} value={fields?.customerMobilePhone?.length === 0 ? '+46' : fields.customerMobilePhone} countryCodeEditable={false} autoFormat={false} name="customerMobilePhone" preferredCountries={PREFERRED_COUNTRIES} onChange={(val) => onPhoneChange(val)} /> : posSession.customerMobilePhone}</div>
                    </div>
                    <div className="d-flex flex-row flex-grow-1 align-items-baseline row">
                      <div className="d-flex col-12 col-sm-4">{getText('possession:CUSTOMER_EMAIL')}:</div>
                      <div className="col-12 col-sm-6 d-flex justify-content-start pd-5">
                        {isEditCustomer ? (
                          <>
                            <Input value={fields.customerEmail} className={`${errors.customerEmail && `input-normal-error-msg`}`} size="sm" name="customerEmail" onChange={onChange} placeholder={getText('possession:CUSTOMER_EMAIL')} />
                            <p className={`error-msg ${!errors.customerEmail && 'hidden'}`}>{errors.customerEmail}</p>
                          </>
                        ) : (
                          posSession.customerEmail
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-grow-1 align-items-baseline row">
                      <div className="d-flex col-12 col-sm-4">{getText('possession:CUSTOMER_VAT')}:</div>
                      <div className="col-12 col-sm-3 d-flex justify-content-start pd-5">{isEditCustomer ? <Input value={fields.customerVatNumber} size="sm" name="customerVatNumber" onChange={onChange} placeholder={getText('possession:CUSTOMER_VAT')} /> : posSession.customerVatNumber}</div>
                    </div>
                    <div className="d-flex flex-row flex-grow-1 align-items-baseline row">
                      <div className="d-flex col-12 col-sm-4">{getText('possession:CUSTOMER_TIN')}:</div>
                      <div className="col-12 col-sm-3 d-flex justify-content-start pd-5">{isEditCustomer ? <Input value={fields.taxpayerIdentificationNumber} maxLength={20} size="sm" name="taxpayerIdentificationNumber" onChange={onChange} placeholder={getText('possession:CUSTOMER_TIN')} /> : posSession.taxpayerIdentificationNumber}</div>
                    </div>
                  </div>
                )}
                <h4>{getText('possession:CHARGING_MEASUREMENT_DATA')}</h4>
                <div className="control-pane">
                  <style>{SAMPLE_CSS}</style>
                  <div className="control-section">
                    <ChartComponent
                      id="charts1"
                      style={{ textAlign: 'center', fontFamily: 'sans-serif' }}
                      primaryXAxis={{
                        valueType: 'DateTime',
                        edgeLabelPlacement: 'Shift',
                        majorGridLines: { width: 0 },
                        labelFormat: 'yyyy-MM-dd HH:mm:ss ',
                        labelRotation: '45',
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      height="300"
                      load={load}
                      primaryYAxis={{
                        rangePadding: 'None',
                        lineStyle: { width: 0 },
                        majorTickLines: { width: 0 },
                        minorTickLines: { width: 0 },
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      chartArea={{ border: { width: 0 } }}
                      tooltip={{ enable: true }}
                      legendSettings={{ enableHighlight: true }}
                      title={getText(`possession:POWER`)}
                      loaded={onChartLoad}
                    >
                      <Inject services={[LineSeries, DateTime, Legend, Tooltip, Highlight]} />
                      <SeriesCollectionDirective>
                        <SeriesDirective dataSource={powerData} xName="x" yName="y" width={2} marker={{ visible: true, width: 6, height: 6, shape: 'Circle', isFilled: false }} type="Line"></SeriesDirective>
                      </SeriesCollectionDirective>
                    </ChartComponent>
                    <ChartComponent
                      id="charts2"
                      style={{ textAlign: 'center' }}
                      primaryXAxis={{
                        valueType: 'DateTime',
                        edgeLabelPlacement: 'Shift',
                        majorGridLines: { width: 0 },
                        labelFormat: 'yyyy-MM-dd HH:mm:ss ',
                        labelRotation: '45',
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      height="300"
                      load={load}
                      primaryYAxis={{
                        rangePadding: 'None',
                        lineStyle: { width: 0 },
                        majorTickLines: { width: 0 },
                        minorTickLines: { width: 0 },
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      chartArea={{ border: { width: 0 } }}
                      tooltip={{ enable: true }}
                      legendSettings={{ enableHighlight: true }}
                      title={getText(`possession:CURRENT`)}
                      loaded={onChartLoad}
                    >
                      <Inject services={[LineSeries, DateTime, Legend, Tooltip, Highlight]} />
                      <SeriesCollectionDirective>
                        <SeriesDirective dataSource={currentData} xName="x" yName="y" width={2} marker={{ visible: true, width: 6, height: 6, shape: 'Circle', isFilled: false }} type="Line"></SeriesDirective>
                      </SeriesCollectionDirective>
                    </ChartComponent>
                    <ChartComponent
                      id="charts3"
                      style={{ textAlign: 'center' }}
                      primaryXAxis={{
                        valueType: 'DateTime',
                        edgeLabelPlacement: 'Shift',
                        majorGridLines: { width: 0 },
                        labelFormat: 'yyyy-MM-dd HH:mm:ss ',
                        labelRotation: '45',
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      height="300"
                      load={load}
                      primaryYAxis={{
                        rangePadding: 'None',
                        lineStyle: { width: 0 },
                        majorTickLines: { width: 0 },
                        minorTickLines: { width: 0 },
                        labelStyle: {
                          fontFamily: '"Source Sans Pro", sans-serif',
                        },
                      }}
                      chartArea={{ border: { width: 0 } }}
                      tooltip={{ enable: true }}
                      legendSettings={{ enableHighlight: true }}
                      title={getText(`possession:STATE_OF_CHARGE`)}
                      loaded={onChartLoad}
                    >
                      <Inject services={[LineSeries, DateTime, Legend, Tooltip, Highlight]} />
                      <SeriesCollectionDirective>
                        <SeriesDirective dataSource={soCData} xName="x" yName="y" width={2} marker={{ visible: true, width: 6, height: 6, shape: 'Circle', isFilled: false }} type="Line"></SeriesDirective>
                      </SeriesCollectionDirective>
                    </ChartComponent>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <Footer pageLanguages={LANGUAGES} onLanguageChange={(opt) => onLanguageChange(opt)} defaultLanguage={filter(LANGUAGES, { code: language })[0].value} />
          </div>
        );
      }}
    </Translation>
  );
}

const mapStateToProps = (state) => selector(state, false, ['authorisation', 'app', 'quickshopweb']);

const mapDispatchToProps = (dispatch) => {
  return {
    attemptGetPOSSession: (data) => dispatch(attemptGetPOSSession(data)),
    attemptUpdateQuickshop: (data) => dispatch(attemptUpdateQuickshop(data)),
    attemptResetNotificationState: (data) => dispatch(attemptResetNotificationState(data)),
    attemptSetLanguage: (data) => dispatch(attemptSetLanguage(data)),
    attemptGetReceiptData: (data) => dispatch(attemptGetReceiptData(data)),
    attemptGetMeasurementData: (data) => dispatch(attemptGetMeasurementData(data)),
    attemptGetTopMeasurementData: (data) => dispatch(attemptGetTopMeasurementData(data)),
  };
};

export default withTranslation('main')(connect(mapStateToProps, mapDispatchToProps)(POSSession));
